var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_631_17)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#FFC700"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_631_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.446 252.387C285.771 232.788 250.654 214.77 214.758 195.957V308.499C252.531 287.964 292.346 269.159 322.602 252.387H322.446Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.446 252.387C285.771 232.788 214.758 195.957 214.758 195.957L309.437 259.593C309.437 259.593 292.19 269.159 322.446 252.387Z",
    fill: "#E8E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.662 396.594C145.483 395.192 119.465 393.93 103.472 390.635C92.6522 388.446 83.2496 383.585 76.3554 376.535C71.027 371.199 66.7895 363.058 63.502 351.763C60.6819 342.353 59.5836 334.524 58.0177 315.4C55.6207 272.238 55.0493 236.951 58.0177 197.522C60.4667 175.748 61.6541 149.901 77.9213 134.821C85.6021 127.763 94.5372 123.222 104.571 121.344C120.244 118.368 187.02 116.016 256.148 116.016C325.12 116.016 392.044 118.368 407.732 121.344C420.266 123.697 432.021 130.747 438.923 139.838C453.765 163.184 454.025 192.216 455.532 214.925C456.155 225.745 456.155 287.184 455.532 298.004C453.187 333.893 451.302 346.591 445.973 359.756C442.678 368.068 439.866 372.453 434.997 377.314C427.362 384.795 417.629 389.77 407.094 391.578C341.172 396.535 285.194 397.611 221.662 396.594ZM322.611 252.387C285.936 232.787 250.819 214.613 214.923 195.8V308.35C252.697 287.815 292.519 269.003 322.767 252.231L322.611 252.387Z",
    fill: "#CD201F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_631_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_631_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 280.96,
    fill: "white",
    transform: "translate(56 116)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.ac97b3941a56ba429b93bd558468bde9.svg";
export { ForwardRef as ReactComponent };